const createImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.crossOrigin = 'anonymous';
    image.src = url;
});

const getCanvasContext = (width, height) => {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Unable to get 2D context from canvas');
    }
    return { canvas, ctx };
};

export const getCroppedImageBlob = async (imageSrc, cropPixels, options = {}) => {
    if (!imageSrc || !cropPixels) {
        throw new Error('Image source and crop parameters are required');
    }

    const {
        mimeType = 'image/jpeg',
        quality = 0.92,
    } = options;

    const image = await createImage(imageSrc);
    const { width, height } = cropPixels;
    const { canvas, ctx } = getCanvasContext(width, height);

    ctx.drawImage(
        image,
        cropPixels.x,
        cropPixels.y,
        width,
        height,
        0,
        0,
        width,
        height
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
            if (!blob) {
                reject(new Error('Canvas is empty'));
                return;
            }
            resolve(blob);
        }, mimeType, quality);
    });
};

export const getCroppedImageFile = async (imageSrc, cropPixels, fileName, options = {}) => {
    const blob = await getCroppedImageBlob(imageSrc, cropPixels, options);
    const mimeType = options.mimeType || blob.type || 'image/jpeg';
    return new File([blob], fileName, { type: mimeType, lastModified: Date.now() });
};
